import React, { useState, useEffect } from "react";
import { Col, Row } from "react-bootstrap";
import IcLixo from "../../components/Svg/IcLixo";
import api from "../../services/api";
import { toast } from "react-toastify";
import DatePicker from "../../components/DatePicker";
import Slct from "../Slct";
import useWrapper from "../../hooks/useWrapper";
import ModalCustom from "./modal-template-default";
import { InputText } from "../Input";
import Required from "../Required";
import Button from "../Button";
import Tooltip2 from "../Tooltip";
import { validateForm, validateStyle } from "../ValidateForm";

const ModalQuestion = props => {
  const { show, refreshCallback, onHide, commercial_id } = props;
  const { me, config } = useWrapper();

  const [isWaitingResponse, setisWaitingResponse] = useState();
  const [isLoadingEssential, setisLoadingEssential] = useState(false);
  const [isLoadingSave, setisLoadingSave] = useState(false);
  useEffect(() => {
    setisWaitingResponse(isLoadingEssential || isLoadingSave);
  }, [isLoadingEssential, isLoadingSave]);

  const [events, setevents] = useState();
  useEffect(() => {
    (async () => {
      try {
        setisLoadingEssential(true);

        const _pre_url = me?.type === "Formando" ? "trainee" : "";
        const { data: _commercial } = await api.get(`${_pre_url}/commercial/${commercial_id}`, config);

        const _events = [{ label: "-- Nenhum --", value: null }].concat(
          _commercial?.eventDates?.map(__event => ({
            label: __event?.events?.name,
            value: __event?.events?.id,
          })) || [],
        );
        setevents(_events);
      } catch (__error) {
        console.log("__error", __error);
        toast.error("Erro ao tentar carregar os eventos.");
      } finally {
        setisLoadingEssential(false);
      }
    })();
    // run once on mount only: config is recreated every render (would cause refetch loops); commercial_id
    // and me.type are fixed for the lifetime of this modal instance
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const [selects, setselects] = useState();
  const [options, setoptions] = useState(["", ""]);

  const createSurvey = async () => {
    const _is_valid = validateForm(document.getElementById("survey_create"));
    if (!_is_valid) return;

    try {
      setisLoadingSave(true);
      const _is_trainee = me?.type === "Formando";
      await api.post(
        `${_is_trainee ? "trainee/" : ""}survey`,
        {
          description: selects?.description,
          open: true,
          ...(!!_is_trainee ? { trainee_id: me?.id } : { user_id: me?.id }),
          commercial_id,
          surveyOptions: options?.map(__option => ({ quest: __option })),
          expires_date: selects?.expires_date,
          event_id: selects?.event_id,
        },
        config,
      );
      closeNReset();
      refreshCallback();
      toast.success("Enquete criada com sucesso!");
    } catch (__error) {
      console.log("__error", __error);
      toast.error("Problemas ao tentar criar enquete.");
    } finally {
      setisLoadingSave(false);
    }
  };

  const closeNReset = () => {
    setselects();
    setoptions(["", ""]);
    onHide();
  };

  return (
    <ModalCustom size="md" show={show} onHide={closeNReset} id="survey_create" style={validateStyle}>
      <ModalCustom.Header>
        <ModalCustom.Title>Nova Enquete</ModalCustom.Title>
      </ModalCustom.Header>
      <ModalCustom.Body>
        <Row>
          <Col>
            <p className="small-label m-0 mb-2">
              Elabore enquetes para os formandos votarem. Personalize perguntas e opções para coletar informações.
            </p>
          </Col>
        </Row>
        <Row>
          <Col>
            <span>
              Questão <Required />
            </span>
            <InputText
              required={true}
              disabled={!!isWaitingResponse}
              value={selects?.description}
              onChange={__ev => {
                setselects({
                  ...selects,
                  description: __ev.target.value,
                });
              }}
            />
          </Col>
        </Row>
        <Row className="mt-2">
          <Col>
            <span>Evento</span>
            <Slct
              options={events || []}
              placeholder="..."
              value={selects?.event_id}
              onChange={__ev => {
                setselects({
                  ...selects,
                  event_id: __ev.value,
                });
              }}
            />
          </Col>
        </Row>
        <Row className="mt-2">
          <Col>
            <span>
              Data de Encerramento <Required />
            </span>
            <DatePicker
              required={true}
              selected={selects?.expires_date}
              changeDate={ev => {
                setselects({
                  ...selects,
                  expires_date: ev,
                });
              }}
              minDate={new Date()}
            />
          </Col>
        </Row>
        <Row className="mt-2">
          <Col>
            <span>
              Opções <Required />
            </span>
            {options?.map((__option, __option_i) => (
              <div className="d-flex align-items-center mt-1">
                <span style={{ width: "18px" }}>{__option_i + 1}.</span>
                <InputText
                  className="pl-2"
                  required={true}
                  disabled={!!isWaitingResponse}
                  value={__option}
                  onChange={__ev => {
                    setoptions(
                      options?.map((__option_val, __option_val_i) =>
                        __option_val_i === __option_i ? __ev.target.value : __option_val,
                      ),
                    );
                  }}
                />
                {options.length > 2 && (
                  <Tooltip2 tip="Remover Opção">
                    <span
                      className="simple-ico ml-2"
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        setoptions(options?.filter((__option_val, __option_val_i) => __option_val_i !== __option_i));
                      }}
                    >
                      <IcLixo />
                    </span>
                  </Tooltip2>
                )}
              </div>
            ))}
            <div className="mt-2">
              <Button
                color="success"
                size="sm"
                onClick={() => {
                  setoptions([...options, ""]);
                }}
                disabled={!!isWaitingResponse}
              >
                Adicionar Opção
              </Button>
            </div>
          </Col>
        </Row>
      </ModalCustom.Body>
      <ModalCustom.Footer>
        <Button color="primary" onClick={createSurvey} disabled={!!isWaitingResponse}>
          Criar Enquete
        </Button>
      </ModalCustom.Footer>
    </ModalCustom>
  );
};

export default ModalQuestion;
